import { ActionTypes } from "../ProjectActionTypes";
import { ProjectJobsStatusModalAction } from "./ProjectJobsStatusModalActions";
import { IProjectJobsStatusModalState, initialProjectJobsStatusModalState } from "./ProjectJobsStatusModalState";

export const ProjectJobsStatusModalReducer = (state: IProjectJobsStatusModalState = initialProjectJobsStatusModalState, action: ProjectJobsStatusModalAction): IProjectJobsStatusModalState => {
  const { type, payload } = action;
  switch (type) {
    case ActionTypes.GET_PROJECT_JOBS_STATUS_LOADING: {
      state.projectId = payload?.projectId
      return { ...state, loaded: false, errorCode: undefined };
    }

    case ActionTypes.GET_PROJECT_JOBS_STATUS_SUCCESS: {
        state.projectId = payload?.projectId
        state.data = payload?.data
        return { ...state, loaded: true, errorCode: undefined };
    }

    case ActionTypes.GET_PROJECT_JOBS_STATUS_ERROR: {
        return {...state, loaded: true, errorCode: payload?.errorCode };
    }

    default:
        return state;
  }
};
